import DashboardOutlined from "@mui/icons-material/DashboardOutlined";
import {lazy} from "react";
import type {Page, PageGroup} from "router/types";

const DashboardPage = lazy(() => import("pages/dashboard/DashboardPage"));

const dashboardRoutes: Array<Page | PageGroup> = [
  {
    segment: "dashboard",
    title: "Dashboard",
    Icon: DashboardOutlined,
    Component: DashboardPage,
  },
];

export default dashboardRoutes;
